import styles from "./SurveyAlreadyCompleted.module.scss";

import { useTranslation } from "react-i18next";

import { CompletedCheckIcon } from "./CompletedCheckIcon";

export const SurveyAlreadyCompleted = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <CompletedCheckIcon className={styles.check} aria-hidden />

      <div className={styles.copy}>
        <h1 className={styles.title}>
          {t("sessionSurvey.alreadyCompleted.title")}
        </h1>
        <p className={styles.subtitle}>
          {t("sessionSurvey.alreadyCompleted.subtitle")}
        </p>
      </div>
    </div>
  );
};
